export const uid = () => (
    typeof crypto !== 'undefined' && crypto.randomUUID
        ? crypto.randomUUID()
        : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`
);

export function greetingFor(date = new Date()) {
    const hour = date.getHours();
    if (hour < 12) return 'Good morning';
    if (hour < 18) return 'Good afternoon';
    return 'Good evening';
}

const clockFormat = new Intl.DateTimeFormat('en-US', { hour: 'numeric', minute: '2-digit' });
const dateFormat = new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric' });
const relativeFormat = new Intl.RelativeTimeFormat('en', { numeric: 'always' });

export const formatClock = (iso) => clockFormat.format(new Date(iso)).replace(/ /g, ' ');
export const formatShortDate = (iso) => dateFormat.format(new Date(iso));

export function dayBucket(iso, now = new Date()) {
    const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
    const startOfYesterday = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1).getTime();
    const time = new Date(iso).getTime();
    if (time >= startOfToday) return 'today';
    if (time >= startOfYesterday) return 'yesterday';
    return 'earlier';
}

export function dayLabel(iso, now = new Date()) {
    const bucket = dayBucket(iso, now);
    if (bucket === 'today') return 'Today';
    if (bucket === 'yesterday') return 'Yesterday';
    return formatShortDate(iso);
}

export function relativeTime(iso, now = Date.now()) {
    const seconds = Math.round((new Date(iso).getTime() - now) / 1000);
    const abs = Math.abs(seconds);
    if (abs >= 86400) return relativeFormat.format(Math.trunc(seconds / 86400), 'day');
    if (abs >= 3600) return relativeFormat.format(Math.trunc(seconds / 3600), 'hour');
    if (abs >= 60) return relativeFormat.format(Math.trunc(seconds / 60), 'minute');
    return 'just now';
}
